import React from "react";
import { Check } from "lucide-react";
import Layout, { useSEO } from "@/components/Layout";
import { Section, Overline, BlueRule } from "@/components/primitives";
import { NewsletterForm } from "@/components/forms";

const BENEFITS = [
  "Practical ideas about better thinking and decision-making",
  "Short, usable frameworks—not empty motivation",
  "Early access to new articles, principles and resources",
  "Notifications about books, programs and workshops",
];

export default function Join() {
  useSEO({ title: "Join | Impactful Mindset", description: "Join the Impactful Mindset audience for practical ideas about better thinking, growth and intentional living." });
  return (
    <Layout>
      <Section className="pt-20 pb-24">
        <div className="max-w-3xl mx-auto text-center">
          <Overline>Join Impactful Mindset</Overline>
          <h1 className="font-serif-display text-4xl sm:text-5xl font-bold mt-4 leading-tight text-[#111827]">
            Ideas worth thinking about
          </h1>
          <BlueRule className="mt-6 mx-auto" />
          <p className="text-lg text-slate-600 mt-6 leading-relaxed">
            Join a growing audience of people who want to think more clearly and live more intentionally. Practical
            insights, delivered directly to your inbox—no spam, no hype.
          </p>
        </div>

        <div className="max-w-xl mx-auto mt-12 border border-slate-200 p-8">
          <ul className="space-y-3 mb-8">
            {BENEFITS.map((b) => (
              <li key={b} className="flex gap-3 text-slate-700"><Check className="text-[#0F2C59] shrink-0 mt-0.5" size={18} /> <span>{b}</span></li>
            ))}
          </ul>
          <NewsletterForm testidPrefix="join-newsletter" />
        </div>
      </Section>
    </Layout>
  );
}
